import api from './api';

const adminService = {
  // Dashboard
  getDashboardStats: async () => {
    const response = await api.get('/admin/dashboard/stats');
    return response.data;
  },

  getRecentGames: async () => {
    const response = await api.get('/admin/dashboard/recent-games');
    return response.data;
  },

  getPopularLocations: async () => {
    const response = await api.get('/admin/dashboard/popular-locations');
    return response.data;
  },

  // Locations
  getLocations: async (params = {}) => {
    const response = await api.get('/admin/locations', { params });
    return response.data;
  },

  getLocation: async (id) => {
    const response = await api.get(`/admin/locations/${id}`);
    return response.data;
  },

  createLocation: async (data) => {
    const response = await api.post('/admin/locations', data);
    return response.data;
  },

  updateLocation: async (id, data) => {
    const response = await api.put(`/admin/locations/${id}`, data);
    return response.data;
  },

  deleteLocation: async (id) => {
    const response = await api.delete(`/admin/locations/${id}`);
    return response.data;
  },

  toggleLocationActive: async (id) => {
    const response = await api.post(`/admin/locations/${id}/toggle-active`);
    return response.data;
  },

  uploadLocationImage: async (id, imageFile) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    const response = await api.post(`/admin/locations/${id}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Drop Locations
  getDropLocations: async (locationId) => {
    const response = await api.get(`/admin/locations/${locationId}/drop-points`);
    return response.data;
  },

  createDropLocation: async (locationId, data) => {
    const response = await api.post(`/admin/locations/${locationId}/drop-points`, data);
    return response.data;
  },

  updateDropLocation: async (locationId, dropLocationId, data) => {
    const response = await api.put(`/admin/locations/${locationId}/drop-points/${dropLocationId}`, data);
    return response.data;
  },

  deleteDropLocation: async (locationId, dropLocationId) => {
    const response = await api.delete(`/admin/locations/${locationId}/drop-points/${dropLocationId}`);
    return response.data;
  },

  // Street View Discovery
  scanStreetView: async (latitude, longitude, radius = 10) => {
    const response = await api.post('/admin/street-view/scan', { latitude, longitude, radius });
    return response.data;
  },

  // Levels (Rank Tiers)
  getLevels: async () => {
    const response = await api.get('/admin/levels');
    return response.data;
  },
  createLevel: async (data) => {
    const response = await api.post('/admin/levels', data);
    return response.data;
  },
  updateLevel: async (id, data) => {
    const response = await api.put(`/admin/levels/${id}`, data);
    return response.data;
  },
  deleteLevel: async (id) => {
    const response = await api.delete(`/admin/levels/${id}`);
    return response.data;
  },
  reorderLevels: async (order) => {
    const response = await api.post('/admin/levels/reorder', { order });
    return response.data;
  },
};

export default adminService;
